import { render, staticRenderFns } from "./labelStyle.vue?vue&type=template&id=1a412ce0&scoped=true&"
import script from "./labelStyle.vue?vue&type=script&lang=js&"
export * from "./labelStyle.vue?vue&type=script&lang=js&"
import style0 from "./labelStyle.vue?vue&type=style&index=0&id=1a412ce0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a412ce0",
  null
  
)

export default component.exports